import { SigninDto } from './../dtos/auth/request/signinDto';
import config from "../config";
import { JwtTokenDto } from "../dtos/auth/response/jwtTokenDto";
import { ResponseDto } from "../dtos/common/responseDto";
import { EmployeeCreateRequestDto } from "../dtos/user/request/employCreateRequestDto";
import { UserResponseDto } from "../dtos/user/response/userResponseDto";
import { getData, patchData, postData } from "../utils/axios/serverHelper";
import { FindIdDto } from '../dtos/auth/request/findIdDto';
import { ChangePasswordDto } from '../dtos/auth/request/changePasswordDto';
import { MenuDto } from '../dtos/menu/menuDto';
import { encryptPassword } from "../utils/auth/passwordEncrypt";

const baseUrl = `${config.apiUrl}/auth`;


export const signin = async (userId: string, userPassword: string) => {
    const url = `${baseUrl}/signin`;

    const payload = {
        userId,
        userPassword: encryptPassword(userPassword)
    };

    // if (process.env.NODE_ENV !== "production") {
    //     console.log("[authApi] signin payload", payload);
    // }

    return await postData<SigninDto, ResponseDto<JwtTokenDto>>(url, {
        ...payload
    })
}

export const findId = async (userName: string, rrnFront: string, rrnBack: string, phoneNumber: string) => {
    const url = `${baseUrl}/find/id`;

    return await postData<FindIdDto, ResponseDto<string>>(url, {
        userName, rrnFront, rrnBack, phoneNumber
    })
}

export const changePassword = async (
    userName: string,
    rrnFront: string,
    rrnBack: string,
    phoneNumber: string,
    userId: string,
    newPassword: string) => {

    const url = `${baseUrl}/password`;

    return await patchData<ChangePasswordDto, ResponseDto<any>>(url, {
        userName, rrnFront, rrnBack, phoneNumber, userId, newPassword: encryptPassword(newPassword)
    })
}


export const getMenuAuth = async (menuCd: string) => {
    const url = `${baseUrl}/${menuCd}`;
    return await getData<MenuDto>(url);
};



export const getUserBySearch = async (keyword: string) => {
    const url = `${baseUrl}/modal`

    return await getData<ResponseDto<UserResponseDto[]>>(url, {
        params: { keyword }  
    });
}

// 🔄 RefreshToken으로 새 토큰 발급
export const refreshTokens = async (refreshToken: string) => {
    const url = `${baseUrl}/refresh`;

    return await postData<{ refreshToken: string }, ResponseDto<JwtTokenDto>>(url, {
        refreshToken
    });
}

// 로그아웃
export const logout = async () => {
    const url = `${baseUrl}/logout`;
    return await postData<Record<string, never>, ResponseDto<void>>(url, {});
}

